/**
 * Base URLs, and nothing else — no `createApi` here, so a service module never
 * pulls the whole store graph in just to learn where the API lives.
 *
 * `VITE_API_BASE_URL` empty (`npm run dev:local`) must yield RELATIVE urls so Vite's
 * proxy reaches the local backend; a hardcoded `http://localhost:5000` fallback is
 * what made the old axios client miss the :5001 backend entirely.
 */
const rawBase = (import.meta.env.VITE_API_BASE_URL ?? '').trim().replace(/\/+$/, '');

/** `/api/*` routers: properties, seller, admin, lawyer, broker, buyer, public. */
export const apiBaseUrl = `${rawBase}/api/`;

/** `/auth/*` and `/user/*` are mounted at the server ROOT, not under `/api`. */
export const rootApiBaseUrl = `${rawBase}/`;

/** Uploaded documents and photos are served as static files, not through a router. */
export const uploadsBaseUrl = `${rawBase}/uploads/`;

/** Absolute url for a stored upload path. Backend rows hold a repo-relative path. */
export const uploadUrl = (storedPath: string): string =>
  `${uploadsBaseUrl}${storedPath.replace(/^\/?(uploads\/)?/, '')}`;
